function isStyleDefinition(obj) {
  return obj && typeof obj === "object" && "className" in obj;
}
function isElementStyles(obj) {
  return obj && typeof obj === "object" && ("element" in obj || "pseudoBefore" in obj || "siblingAfter" in obj || "subElement" in obj);
}
function isElementBuilder(obj) {
  return obj && typeof obj === "object" && "build" in obj && typeof obj.build === "function";
}
function isElementModel(obj) {
  return obj && typeof obj === "object" && "element" in obj && "styles" in obj && obj.element instanceof HTMLElement;
}
export {
  isElementBuilder,
  isElementModel,
  isElementStyles,
  isStyleDefinition
};
//# sourceMappingURL=types.js.map
